// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","ScreenSMMin":"(min-width: 768px)","recipeTag":"Ga7e8e6"};